/* ACTIONS */
import * as types from './types';

export const updateAbortController = (abortControllerResource) => ({
  type: types.UPDATE_ABORT_CONTROLLER_RESOURCE,
  payload: abortControllerResource,
});
